import * as React from "react";
import * as ReactDOM from "react-dom";
import App from "./mobile/App";
import "./index.scss";
import Es6Promise from "es6-promise";
import { JJMATCH_STATIC_PAGE } from "./lib/utils/Const";
import GameConfig from "./GameConfig";

Es6Promise.polyfill();

const win: any = window;

let rootId = "root";
if (win[JJMATCH_STATIC_PAGE]) {
    rootId = "root2";
}

if (win.Logger && win.Logger.setBaseUpOptions) {
    win.Logger.setBaseUpOptions({
        type: ["share", "net", "browser", "device", "sdk", "page"],
    });
    win.Logger.baseProfessionProps.activityId = `${GameConfig.server}_${GameConfig.gameId}`;
}

ReactDOM.render(<App />, document.getElementById(rootId) as HTMLElement);
